import { Injectable, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { AuthResponseModel } from '../models/core/auth-response.model';
import { RolesEnum } from '../models/enums/roles.enum';
import { OptionalType } from '../models/types/optional.type';
import { SecurityStorage } from './storage/security.storage';

/**
 * Logged user's data.
 */
@Injectable({
    providedIn: 'root'
})
export class UserSessionService {
    /**
     * Reference to the terms of service dialog if it is currently open.
     * Can be used to delay actions until the user has accepted the terms.
     */
    termsDialogRef?: MatDialogRef<any>;

    private readonly securityStorage = inject(SecurityStorage);

    get userInfo(): OptionalType<AuthResponseModel> {
        return this.securityStorage.getUserInfo();
    }

    get roleId(): number {
        return this.userInfo?.roleId ?? 0;
    }

    get hasNetvoteRole(): boolean {
        return this.roleId === RolesEnum.Netvote;
    }

    get hasApprovalRight(): boolean {
        return this.userInfo?.approvalRight ?? false;
    }
}
